export default __webpack_public_path__ + "static/media/image 29.52de376a.png";